import { Heading } from '@components/gassan-ui/Typography/Heading'
import { Icon } from '@gassan-ui'
import { cn } from '@lib/cn'
import { HTMLMotionProps, motion } from 'framer-motion'
import { PropsWithChildren } from 'react'

type Props = PropsWithChildren<
  HTMLMotionProps<'div'> & {
    label: string
    isActive: boolean
    hasChildren?: boolean
    onClick: () => void
  }
>

function Row({ isActive, hasChildren = true, children, label, onClick, ...rest }: Props) {
  return (
    <motion.div
      className={cn('absolute z-[1] w-full bg-pampasLight', isActive && 'z-[2] min-h-full')}
      {...rest}
    >
      <button
        className={cn(
          'relative flex w-full items-center justify-between bg-pampas outline-0',
          'relative z-[1] h-[56px] px-4',
          'md:h-[90px] md:px-8',
          isActive && 'border-b border-tabaccoBrown/10',
        )}
        data-variant="h2"
        onClick={onClick}
      >
        <Heading variant="h2" as="span">
          {label}
        </Heading>
        {hasChildren && <Icon icon={isActive ? 'chevron-up-small' : 'chevron-down-small'}></Icon>}
      </button>
      {isActive && (
        <motion.div
          className={cn('pb-24 md:pb-32')}
          initial={{ opacity: 0, display: 'none' }}
          animate={{ opacity: 1, display: 'block' }}
          transition={{ delay: 0.4, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      )}
    </motion.div>
  )
}

export default Row
